export function expandable(el, 
  {
    selector = '.expandable',
    buttonSelector = selector + '__button',
    contentSelector = selector + '__wrapper',
  } = {}) {
  const button = el.querySelector(buttonSelector);
  const content = el.querySelector(contentSelector);

  let animation = null;
  let isClosing = false;
  let isExpanding = false;
  
  button.addEventListener('click', (e) => onClick(e));

  function onClick(e) {
    e.preventDefault();
    content.style.overflow = 'hidden';

    if (isClosing || !el.hasAttribute('open')) {
      open();
    } else if (isExpanding || el.hasAttribute('open')) {
      close();
    }
  }

  function close() {
    const startHeight = content.offsetHeight + 'px';
    const endHeight = '0px';
    const opacity = content.style.opacity || 1;
    isClosing = true;

    if (animation) {
      animation.cancel();
    }

    animation = content.animate({
      height: [startHeight, endHeight],
      opacity: [opacity, 0],
    }, {
      duration: 250,
      easing: 'ease-out',
    });

    animation.onfinish = () => onAnimationFinish(false);
    animation.oncancel = () => isClosing = false;
  }

  function open() {
    content.style.height = content.offsetHeight + 'px';
    el.setAttribute('open', '');
    window.requestAnimationFrame(() => expand());
  }

  function expand() {
    const startHeight = content.offsetHeight + 'px';
    const endHeight = content.firstElementChild.offsetHeight + 'px';
    const opacity = content.style.opacity || 0;
    isExpanding = true;

    if (animation) {
      animation.cancel();
    }

    animation = content.animate({
      height: [startHeight, endHeight],
      opacity: [opacity, 1],
    }, {
      duration: 250,
      easing: 'ease-out',
    });

    animation.onfinish = () => onAnimationFinish(true);
    animation.oncancel = () => isExpanding = false;
  }

  function onAnimationFinish(isOpen) {
    el.toggleAttribute('open', isOpen);
    animation = null;
    isClosing = false;
    isExpanding = false;
    content.style.height = content.style.overflow = '';
  }
}
